export default __webpack_public_path__ + "media/zurb/img/playground/isaac-asimov-5619be80747f3391f553148b636506c6.jpg";